import BaseApi from "@api/base.api";
import Http from "@services/http";

export default class TagApi extends BaseApi {
    static get entity() {
        return "tags";
    }

    static async list(params = {}) {
        // Disable global loader for tag suggestions lookups
        return await Http.get(`${this.entity}`, params, { 'X-Disable-Global-Loader': true });
    }
}
